import Vue from "vue";
import Router from "vue-router";
// import { auth } from "./plugins/firebase";
import store from "./store";

// import IndexPage from "./views/IndexPage.vue";
// import ShopTopPage from "./views/ShopTopPage.vue";
import ShopRootPage from "./views/ShopRootPage.vue";
import MenuList from "./components/MenuList.vue";
import Menu from "./components/Menu.vue";
import Cart from "./components/Cart.vue";
import HistoryList from "./components/HistoryList.vue";
import History from "./components/History.vue";
import Order from "./components/Order.vue";
import About from "./components/About.vue";
import Law from "./components/Law.vue";
import OrderStep from "./components/OrderStep.vue";
import PaySelect from "./components/PaySelect.vue";
import Completed from "./components/Completed.vue";
import Cancelled from "./components/Cancelled.vue";
import PrivacyPolicy from "./components/PrivacyPolicy.vue";
import PayError from "./components/pay/Error.vue";
import Error from "./components/error/Error.vue";
import NotFoundError from "./components/error/NotFoundError.vue";

// debug
import DebugTop from "./components/debug/DebugTop.vue";

Vue.use(Router);

const routes = [
  // { path: "/", component: IndexPage }, //TODO サイトトップ
  // { path: "", name: "NotFoundError", component: NotFoundError, meta: { allowPc: true, hideArrow: true } },
  { path: "/policy", name: "Policy", component: PrivacyPolicy, meta: { allowPc: true, hideArrow: true } },
  {
    path: "/:shopId",
    component: ShopRootPage,
    props: true,
    children: [
      // { path: "", component: ShopTopPage }, //TODO 店舗トップ
      // { path: "", name: "NotFoundError", component: NotFoundError, meta: { allowPc: true, hideArrow: true } },
      { path: "menu", name: "MenuList", component: MenuList, meta: { auth: true } },
      { path: "menu/:id", name: "Menu", component: Menu, meta: { auth: true } },
      { path: "cart", name: "Cart", component: Cart, meta: { auth: true } },
      { path: "order-history", name: "OrderHistoryList", component: HistoryList, meta: { auth: true } },
      { path: "order-history/:id", name: "OrderHistory", component: History, meta: { auth: true } },
      { path: "order", name: "Order", component: Order, meta: { auth: true } },
      { path: "about", name: "About", component: About, },
      { path: "law", name: "Law", component: Law, meta: { auth: true } },
      { path: "order-step", name: "OrderStep", component: OrderStep, meta: { auth: true } },
      { path: "error", name: "Error", component: Error, meta: { allowPc: true, hideArrow: true } },
      // Pay 関係
      { path: "select", name: "PaySelect", component: PaySelect, meta: { auth: true } },
      { path: "pay/completed", component: Completed, meta: { allowPc: true, hideArrow: true } }, // LINEPay
      { path: "pay/completed/:id", component: Completed, meta: { allowPc: true, hideArrow: true } }, // PayPay
      { path: "pay/cancelled", name: "PayCancelled", component: Cancelled, meta: { allowPc: true, hideArrow: true } },
      { path: "pay/error", name: "PayError", component: PayError, meta: { allowPc: true, hideArrow: true } },
      // debug
      { path: "debug", name: "Debug", component: DebugTop },
      // 404
      { path: "*", name: "NotFoundError", component: NotFoundError, meta: { allowPc: true, hideArrow: true } },
    ]
  },

];

/* eslint-disable */
const router = new Router({
  routes,
  mode: "history",
  scrollBehavior (to, from, savedPosition) {
    // console.log(`###savedPosition:${savedPosition}`);
    if (savedPosition) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(savedPosition);
        });
      });
    }
    return { x: 0, y: 0 };
  },
});

// Navigation Guard
router.beforeEach(async (to, from, next) => {
  // PCサイト許可？
  const allowPc = to.matched.some((record) => record.meta.allowPc);
  store.state.allowPc = allowPc;

  // 戻る矢印 表示切替
  const hideArrow = to.matched.some((record) => record.meta.hideArrow);
  store.state.arrow = !hideArrow;

  // 認証が必要かどうか？(auth が true)
  // const requiresAuth = to.matched.some((record) => record.meta.auth);
  // if (requiresAuth) {
  //   // Firebase Auth ユーザ情報
  //   const user = auth.currentUser;
  //   console.log(`[router]user=${user}`);

  //   // 認証が必要 かつ Firebase Auth ログインしていない(=ユーザ情報がない)場合は、
  //   // ログイン画面へ遷移 -> ログイン完了後にリダイレクト
  //   if (!user) {
  //     next({
  //       path: "/login",
  //       query: { redirect: to.fullPath },
  //     });
  //   } else {
  //     next();
  //   }
  // } else {
  //   next();
  // }
  next();
});
router.afterEach(async (to, from, next) => {
  // 戻る制御
  const state = history.state
  if (state.canGoBack === undefined) { // router#push 等による遷移
    const stateCopy = Object.assign({}, state);
    stateCopy.canGoBack = true;
    history.replaceState(stateCopy, '')
  }
})
/* eslint-enable */

export default router;
